// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"835ab878","987":"835ab878"}[chunkId] + ".chunk.css";
};